<template>
  <div class="types-div" :style="{backgroundImage:`url(${bgimage})`}">
    <van-tabs v-model="active">
      <van-tab title="慢病康复">
        <template #title>
          <div class="tab-title">慢病康复</div>
        </template>
        <van-cell title="抬腿" label="力量训练" class="item-cell" title-class="item-title" label-class="item-label" to="/knee-lift"  :style="{backgroundImage:`url(${bgKneeLift})`}"></van-cell>
        <van-cell title="体侧屈" label="腰腹训练" class="item-cell" title-class="item-title" label-class="item-label" to="/body-flexion" :style="{backgroundImage:`url(${bgBodyFlexion})`}"></van-cell>
        <van-cell title="肩部拉伸" label="拉伸运动" class="item-cell" title-class="item-title" label-class="item-label" to="/shoulder" :style="{backgroundImage:`url(${bgShoulder})`}"></van-cell>
      </van-tab>
      <van-tab title="青少年体育">
        <template #title>
          <div class="tab-title">青少年体育</div>
        </template>
        <van-cell title="深蹲" label="臀腿训练" class="item-cell" title-class="item-title" label-class="item-label" to="/squats" :style="{backgroundImage:`url(${bgSquats})`}"></van-cell>
        <van-cell title="开合跳" label="全身运动" class="item-cell" title-class="item-title" label-class="item-label" to="/oc-jump" :style="{backgroundImage:`url(${bgOcJump})`}"></van-cell>
        <van-cell title="弯腰触地" label="拉伸运动" class="item-cell" title-class="item-title" label-class="item-label" to="/bend-over" :style="{backgroundImage:`url(${bgBendOver})`}"></van-cell>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import {Field, Button, Toast, Cell, CellGroup, Row, Col, Tab, Tabs} from 'vant'
export default {
  name: 'ExerciseTypes',
  components: {
    [Field.name]: Field,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Row.name]: Row,
    [Col.name]: Col,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button
  },
  data(){
    return {
      bgimage: require('@/assets/css/types_bg.png'),
      bgKneeLift: require('@/assets/css/knee_lift.png'),
      bgBodyFlexion: require('@/assets/css/body_flexion.png'),
      bgShoulder: require('@/assets/css/shoulder.png'),
      bgSquats: require('@/assets/css/squats.png'),
      bgOcJump: require('@/assets/css/oc_jump.png'),
      bgBendOver: require('@/assets/css/bend_over.png'),
      active: 0
    }
  },
  mounted() {
    this.active = this.$route.query?.type
  }
}
</script>

<style scoped>
  .tab-title{
    font-size: 4rem;
    color: #194ea7;
    font-weight: bold;
  }
  .item-cell{
    line-height: 6rem;
    margin: 2rem;
    width: 90%;
    background-color: transparent;
    background-repeat: no-repeat;
    color: #194ea7;
    padding-left: 5%;
    padding-bottom: 10rem;
    background-size: 100% 100%;
  }
  .item-title{
    font-size: 3rem;
    font-weight: bold;
  }
  .item-label{
    font-size: 3rem;
    font-weight: bold;
    color: #a5c0ee;
  }
  .types-div{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: white;
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y:bottom;
  }
</style>
<style>
  .van-tabs--line .van-tabs__wrap{
    height: 75px;
  }
  .van-tab__text--ellipsis{
    overflow: visible;
  }
</style>
